import { css } from 'styled-components';
import { map } from '../../breakpoint';
import { p, px, py, pt, pb, pl, pr, pbs, pie, pbe, pis, pbl, pi } from '../../spacing';
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const paddings = ()=>css`
  ${({ padding })=>map(padding, (val)=>val !== undefined && css`
          ${p(val)};
        `)};

  ${({ paddingHorizontal } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingHorizontal, (val)=>val !== undefined && css`
          ${px(val)};
        `)};

  ${({ paddingVertical } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingVertical, (val)=>val !== undefined && css`
          ${py(val)};
        `)};

  ${({ paddingTop } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingTop, (val)=>val !== undefined && css`
          ${pt(val)};
        `)};

  ${({ paddingBottom } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingBottom, (val)=>val !== undefined && css`
          ${pb(val)};
        `)};

  ${({ paddingLeft } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingLeft, (val)=>val !== undefined && css`
          ${pl(val)};
        `)};

  ${({ paddingRight } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingRight, (val)=>val !== undefined && css`
          ${pr(val)};
        `)};

  ${({ paddingBlockStart } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingBlockStart, (val)=>val !== undefined && css`
          ${pbs(val)};
        `)};

  ${({ paddingInlineEnd } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingInlineEnd, (val)=>val !== undefined && css`
          ${pie(val)};
        `)};

  ${({ paddingBlockEnd } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingBlockEnd, (val)=>val !== undefined && css`
          ${pbe(val)};
        `)};

  ${({ paddingInlineStart } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingInlineStart, (val)=>val !== undefined && css`
          ${pis(val)};
        `)};

  ${({ paddingBlock } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingBlock, (val)=>val !== undefined && css`
          ${pbl(val)};
        `)};

  ${({ paddingInline } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(paddingInline, (val)=>val !== undefined && css`
          ${pi(val)};
        `)};
`;

//# sourceMappingURL=padding.js.map